import {
  Create,
  Edit,
  SimpleForm,
  TextField,
  DateField,
  Resource,
  Show,
  Datagrid,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  EditButton,
  AutocompleteInput,
} from "react-admin";
import VersionedList, {
  DbVersionFilterInput,
  DbVersionField,
  DbVersionInput,
} from "../components/DbVersion";

// Define finishing types
const FINISHING_TYPES = [
  { id: "Finishing, type unknown", name: "Finishing, type unknown" },
  { id: "Unknown if finished", name: "Unknown if finished" },
];

const Filters = [
  <ReferenceInput
    key="finishingArticleCategory"
    label="Article category"
    source="articleCategoryId"
    reference="articleCategory"
    alwaysOn
    filterToQuery={searchText => ({ name: searchText })}
  >
    <AutocompleteInput optionText="name" />
  </ReferenceInput>,
  <DbVersionFilterInput key="finishingDbVersion" alwaysOn />,
];

const DefaultArticleFinishingList = (props) => {
  return (
    <VersionedList {...props} filters={Filters}>
      <div style={{ marginTop: '15px' }}>
        <Datagrid rowClick="show">
          <TextField source="id" />
          <ReferenceField
            label="Article category"
            source="articleCategoryId"
            reference="articleCategory"
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField
            label="Finishing"
            source="finishingId"
            reference="process/finishing"
          >
            <TextField source="name" />
          </ReferenceField>
          <TextField source="type" label="Type" />
          <DbVersionField />
          <DateField source="createdAt" label="Creation date" />
          <DateField source="updatedAt" label="Update date" />
          <EditButton />
        </Datagrid>
      </div>
    </VersionedList>
  );
};

const ShowDefaultArticleFinishing = (props) => {
  return (
    <Show {...props}>
      <SimpleForm>
        <TextField source="id" />
        <ReferenceField 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
        >
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField 
          label="Finishing" 
          source="finishingId" 
          reference="process/finishing"
        >
          <TextField source="name" />
        </ReferenceField>
        <TextField source="type" label="Type" />
        <DbVersionField />
        <DateField source="createdAt" label="Creation date" />
        <DateField source="updatedAt" label="Update date" />
      </SimpleForm>
    </Show>
  );
};

const CreateDefaultArticleFinishing = (props) => {
  return (
    <Create {...props}>
      <SimpleForm>
        <ReferenceInput 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput 
          label="Finishing" 
          source="finishingId" 
          reference="process/finishing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <AutocompleteInput optionText="name" />
        </ReferenceInput>
        <SelectInput
          source="type"
          label="Type"
          choices={FINISHING_TYPES}
        />
        <DbVersionInput />
      </SimpleForm>
    </Create>
  );
};

const EditDefaultArticleFinishing = (props) => {
  return (
    <Edit {...props}>
      <SimpleForm>
        <ReferenceInput 
          label="Article category" 
          source="articleCategoryId" 
          reference="articleCategory"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <ReferenceInput 
          label="Finishing" 
          source="finishingId" 
          reference="process/finishing"
          filterToQuery={searchText => ({ name: searchText })}
        >
          <SelectInput optionText="name" />
        </ReferenceInput>
        <SelectInput
          source="type"
          label="Type"
          choices={FINISHING_TYPES}
        />
        <DbVersionInput />
      </SimpleForm>
    </Edit>
  );
};

const defaultArticleFinishingResource = () => (
  <Resource
    name="defaultArticleFinishings"
    options={{ label: 'Default Article Finishing', menuGroup: 'Bcome' }}
    list={DefaultArticleFinishingList}
    create={CreateDefaultArticleFinishing}
    edit={EditDefaultArticleFinishing}
    show={ShowDefaultArticleFinishing}
  />
);

export default defaultArticleFinishingResource;
